import React, { useState, useEffect } from "react";
import { Table, ChevronDownIcon, CaptionText, ChevronUpIcon, DownloadIcon, LoadingSpinner, ContextualAlert, Tooltip, Link } from "@paypalcorp/pp-react";
import ReactHtmlParser from "react-html-parser";
import { get } from "lodash";
import * as FPT from "../../utility/fpt";
import { launchRedirect } from '../../lib/validate';
import withTheme from "../../common/withTheme";

const MonthwisePayoutTable = (props) => {
  const [showPayoutDetails, setShowPayoutDetails] = useState([]);
  const [partnerwisePayoutLoader, setPartnerwisePayoutLoader] = useState({});
  const [partnerwisePayoutData, setPartnerwisePayoutData] = useState([]);
  const [rowId, setRowId] = useState("");
  const [partnerwisePayoutError, setPartnerwisePayoutError] = useState(false);

  useEffect(() => {
    setShowPayoutDetails(props.showPayoutDetails);
    setPartnerwisePayoutLoader(props.partnerwisePayoutLoader);
    setPartnerwisePayoutData(props.partnerwisePayoutData);
    setRowId(props.rowId);
    setPartnerwisePayoutError(props.partnerwisePayoutError);
  }, [
    props.showPayoutDetails,
    props.partnerwisePayoutLoader,
    props.partnerwisePayoutData,
    props.rowId,
    props.partnerwisePayoutError,
  ]);

  const downloadMonthlyProductWisePayout = (evt, payoutDate) => {
    evt.stopPropagation();
    FPT.trackButtonClick(`downloadMonthlyProductWisePayout|${payoutDate}`);
    launchRedirect(`downloadMonthlyProductWisePayout?payoutDateFrom=${payoutDate.replace(/-/g, "")}&payoutDateTo=${payoutDate.replace(/-/g, "")}`, true);
  };

  let appendPartnerWisePayout = props.monthwisePayoutData[rowId] || {};
  appendPartnerWisePayout["monthwisePartnertDataList"] = partnerwisePayoutData || {};
  props.monthwisePayoutData.monthwisePartnertDataList = props.monthwisePayoutData.monthwisePartnertDataList || [];

  let renderMonthwisePayoutData = props.monthwisePayoutData.map((result, index) => {
    let payoutMsg = "";
    if (result.payout_status === "0") {
      payoutMsg =
        result.payout_mode && result.payout_mode === "CHEQUE"
          ? props.dashboardPageMsg.dashboad.chqPayment
          : props.dashboardPageMsg.dashboard.ppPayment;
    } else if (result.payout_status === "1") {
      payoutMsg =
        result.payout_mode && result.payout_mode === "CHEQUE"
          ? props.dashboardPageMsg.dashboard.chqPaymentFailed
          : props.dashboardPageMsg.dashboard.ppPaymentFailed;
    } else if (result.payout_status === "2") {
      payoutMsg =
        result.payout_mode && result.payout_mode === "CHEQUE"
          ? props.dashboardPageMsg.dashboard.chqPaymentDeposited
          : "";
    }
    const downloadMonthPayoutMsg = props.dashboardPageMsg.dashboard.downloadMonthPayout.replace('{PAIDOUT_DATE}', `${result.paidOutDate}`);

    return (
      <React.Fragment>
        <tr key={index} className={`monthwisePayout ${result.payout_status == "1" ? "paymentFailed" : ""}`} onClick={() => props.handleRowExpansion(index, result.payout_date)}>
          <td className="date">
            <span>{result.paidOutDate}</span>
          </td>
          <td>
            <div>{props.dashboardPageMsg.dashboard.ppgf.label}</div>
            <div className={result.payout_status == "2" ? "paymentPayoutMsg" : ""}>
              <CaptionText className="paidMode">{payoutMsg}</CaptionText>
            </div>
          </td>
          <td style={{ textAlign: "right" }}>
            <span className="paidMode">{result.monthTotalAmount}</span>
          </td>
          <td style={{ textAlign: "right" }}>
            {showPayoutDetails.includes(index) &&
              <Link onClick={(evt) => downloadMonthlyProductWisePayout(evt, result.payout_date) } style={{ paddingRight: "24px" }} className="monthlyPayoutDownload" aria-label={downloadMonthPayoutMsg}>
                <DownloadIcon alt="" name="v2-download" size="sm" />
              </Link>
            }
            {/* Dont show expand icon for failed payment */}
            {result.payout_status !== "1" &&
              <React.Fragment>
                {showPayoutDetails.includes(index) ?
                  <ChevronUpIcon size="xs" style={{ color: "#1040C1" }} />
                  :
                  <ChevronDownIcon size="xs" style={{ color: "#1040C1" }} />
                }
              </React.Fragment>}
          </td>
        </tr>

        {/* To show loader on click of indiviual row */}
        {showPayoutDetails.includes(index) && partnerwisePayoutLoader[index] && (
          <tr key={"partnerwiseLoader" + index} style={{ background: "#FAFAFA", verticalAlign: "top" }}>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div className="monthwiseLoader">
                <LoadingSpinner size="md" screenReaderText={props.dashboardPageMsg.loading} />
              </div>
            </td>
          </tr>
        )}

        {/* Error case for partnerWise payouts */}
        {showPayoutDetails.includes(index) &&
          result.monthwisePartnertDataList &&
          partnerwisePayoutError &&
          !partnerwisePayoutLoader[index] && (
            <tr key={"productwiseData" + index} style={{ background: "#FAFAFA", verticalAlign: "top" }} className="payoutDetailsTable">
              <td colSpan="4" style={{ textAlign: "center" }}>
                <ContextualAlert type="error">
                  {props.dashboardPageMsg.dashboard.payoutDetailErr}
                </ContextualAlert>
              </td>
            </tr>
          )}

        {showPayoutDetails.includes(index) &&
          result.monthwisePartnertDataList &&
          result.monthwisePartnertDataList.map((mwPayoutResult, indx) => {
            return (
              <tr key={"program" + indx} style={{ background: "#FAFAFA", verticalAlign: "top" }} className="payoutDetailsTable">
                <td>
                  <CaptionText>
                    {get(mwPayoutResult, "partner_name", "")}
                  </CaptionText>
                  {mwPayoutResult.partner_name == "Refunds and adjustments" && (
                    <Tooltip className="partnerPopOverContent" description={ReactHtmlParser(props.dashboardPageMsg.dashboard.popOverContent)} />
                  )}
                </td>
                <td>
                  {mwPayoutResult.program_monthly_payouts_list.map(
                    (mwProgramPayoutResult) => {
                      return (
                        <CaptionText style={{ color: "#515354" }}>
                          {get(mwProgramPayoutResult, "description", "")}
                        </CaptionText>
                      );
                    }
                  )}
                </td>
                <td style={{ textAlign: "right" }}>
                  {mwPayoutResult.program_monthly_payouts_list.map(
                    (mwProgramPayoutAmount) => {
                      const showAmountSign = mwProgramPayoutAmount.amount_sign.toString() == 'neg';
                      return (
                        <CaptionText style={{ color: "#515354" }}>
                          {showAmountSign ? <span className="neg" /> : ''}
                          {get(mwProgramPayoutAmount, "programPayoutAmount", "")}
                        </CaptionText>
                      );
                    }
                  )}
                  <CaptionText style={{ color: "#25694F" }}>
                    {props.dashboardPageMsg.dashboard.totalTxt}&nbsp;
                    {(() => {
                      let amountSign = mwPayoutResult.amount_sign.toString();
                      return amountSign == 'neg' ? <span className="neg" /> : '';
                    })()}
                    {get(mwPayoutResult, "partnerTotalAmount", "")}
                  </CaptionText>
                </td>
                <td />
              </tr>
            );
          })}
      </React.Fragment>
    );
  });

  return (
    <React.Fragment>
      <section id="monthwisePayoutResult">
        <Table isFullWidth>
          <thead>
            <tr>
              <th>{props.dashboardPageMsg.dashboard.payoutDate}</th>
              <th>{props.dashboardPageMsg.dashboard.receivedFrom}</th>
              <th style={{ textAlign: "right" }}>
                {props.dashboardPageMsg.dashboard.totalAmount}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {renderMonthwisePayoutData.length == 0 && props.monthwisePayoutDataError &&
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  <ContextualAlert type="error">
                    {props.dashboardPageMsg.dashboard.tryLater}
                  </ContextualAlert>
                </td>
              </tr>
            }
            {props.monthwisePayoutLoader &&
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  <div className="monthwiseLoader">
                    <LoadingSpinner size="md" screenReaderText={props.dashboardPageMsg.loading} />
                  </div>
                </td>
              </tr>
            }
            {renderMonthwisePayoutData.length == 0 && props.monthwisePayoutNoRecordsMsg ?
              <tr>
                <td colSpan="4" style={{ textAlign: "center" }}>
                  <CaptionText style={{ margin: '10px' }}>
                    {props.dashboardPageMsg.dashboard.noPayoutRecords}
                  </CaptionText>
                </td>
              </tr>
              :
              renderMonthwisePayoutData
            }
          </tbody>
        </Table>
      </section>
    </React.Fragment>
  );
};
export default withTheme(MonthwisePayoutTable);
